/** Spread onto inputs to discourage browser autofill / phone suggestions. */
export function noAutofillProps(extra = {}) {
  const userOnFocus = extra.onFocus;
  const userOnTouchStart = extra.onTouchStart;
  const userOnMouseDown = extra.onMouseDown;
  const userOnPointerDown = extra.onPointerDown;
  const {
    onFocus: _ignoredFocus,
    onTouchStart: _ignoredTouchStart,
    onMouseDown: _ignoredMouseDown,
    onPointerDown: _ignoredPointerDown,
    autoComplete = 'off',
    ...rest
  } = extra;

  // iOS Safari will not open the keyboard for a readonly input. Clearing
  // readonly only in onFocus is too late — remove it on the preceding
  // pointer/touch/mouse event so the field is editable when focus lands.
  const clearReadOnly = (e) => {
    if (e.currentTarget?.hasAttribute?.('readonly')) {
      e.currentTarget.removeAttribute('readonly');
    }
  };

  return {
    autoComplete,
    autoCorrect: 'off',
    autoCapitalize: 'off',
    spellCheck: false,
    readOnly: true,
    ...rest,
    onTouchStart: (e) => {
      clearReadOnly(e);
      userOnTouchStart?.(e);
    },
    onMouseDown: (e) => {
      clearReadOnly(e);
      userOnMouseDown?.(e);
    },
    onPointerDown: (e) => {
      clearReadOnly(e);
      userOnPointerDown?.(e);
    },
    onFocus: (e) => {
      clearReadOnly(e);
      userOnFocus?.(e);
    },
  };
}
